
export default {

    // Seznam názvů krajů
    VytvorSeznamKraj(VybSeznamLhc) {
        var Seznam = [];

        // pro všechny Lhc, pro všechny jejich kraje vybrat název a sloučit do jednoho pole
        VybSeznamLhc.forEach(
            function (item) {
                Seznam = Seznam.concat(
                    item.KRAJs.map(
                        function (item) {
                            return item.KRAJ_POPIS;
                        }
                    )
                )
            }
        )
        // odstranit duplicity a setřídit
        Seznam = Seznam.filter((item, index) => {
            return (Seznam.indexOf(item) == index)
        })

        return Seznam.sort();
    },

    // Seznam názvů Orp
    VytvorSeznamOrp(VybSeznamLhc) {
        var Seznam = [];

        // pro všechny Lhc, pro všechny jejich orp vybrat název a sloučit do jednoho pole
        VybSeznamLhc.forEach(
            function (item) {
                Seznam = Seznam.concat(
                    item.ORPs.map(
                        function (item) {
                            return item.ORP_POPIS;
                        }
                    )
                )
            }
        )

        // odstranit duplicity a setřídit
        Seznam = Seznam.filter((item, index) => {
            return (Seznam.indexOf(item) == index)
        })

        return Seznam.sort();
    },

    // Seznam názvů Ku
    VytvorSeznamKuNaz(VybSeznamLhc) {
        var Seznam = [];

        // pro všechny Lhc, pro všechny jejich ku vybrat název a sloučit do jednoho pole
        VybSeznamLhc.forEach(
            function (item) {
                Seznam = Seznam.concat(
                    item.KATUZEs.map(
                        function (item) {
                            return item.KATUZE_POPIS;
                        }
                    )
                )
            }
        )

        // odstranit duplicity a setřídit
        Seznam = Seznam.filter((item, index) => {
            return (Seznam.indexOf(item) == index)
        })

        return Seznam.sort();
    },

    // Seznam kódů Ku
    VytvorSeznamKuKod(VybSeznamLhc) {
        var Seznam = [];

        // pro všechny Lhc, pro všechny jejich ku vybrat název a sloučit do jednoho pole
        VybSeznamLhc.forEach(
            function (item) {
                Seznam = Seznam.concat(
                    item.KATUZEs.map(
                        function (item) {
                            return item.KATUZE_KOD;
                        }
                    )
                )
            }
        )

        // odstranit duplicity a setřídit
        Seznam = Seznam.filter((item, index) => {
            return (Seznam.indexOf(item) == index)
        })

        return Seznam.sort();
    },


    // Seznam LHP_OD
    VytvorSeznamLHP_OD(VybSeznamLhc) {
        var Seznam = [];
        Seznam = VybSeznamLhc.map(
            function (item) {
                return item.LHP_OD;
            })
        // odstranit duplicity a setřídit
        Seznam = Seznam.filter((item, index) => {
            return (Seznam.indexOf(item) == index)
        })
        return Seznam.sort();
    },

    // Seznam LHP_DO
    VytvorSeznamLHP_DO(VybSeznamLhc) {
        var Seznam = [];
        Seznam = VybSeznamLhc.map(
            function (item) {
                return item.LHP_DO;
            })
        // odstranit duplicity a setřídit
        Seznam = Seznam.filter((item, index) => {
            return (Seznam.indexOf(item) == index)
        })
        return Seznam.sort();
    },


    // Hledat kraj v seznamu podle názvu
    SearchKraj(seznam, value) {
        return seznam.some(function (arrVal) {
            return value === arrVal.KRAJ_POPIS;
        });
    },
    // Hledat Orp v seznamu podle názvu
    SearchOrp(seznam, value) {
        return seznam.some(function (arrVal) {
            return value === arrVal.ORP_POPIS;
        });
    },
    // Hledat ku v seznamu podle názvu
    SearchKuNaz(seznam, value) {
        return seznam.some(function (arrVal) {
            return value === arrVal.KATUZE_POPIS;
        });
    },
    // Hledat ku v seznamu podle kodu
    SearchKuKod(seznam, value) {
        return seznam.some(function (arrVal) {
            return value === arrVal.KATUZE_KOD;
        });
    },




}